import React, { useEffect, useState } from "react";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import StarRating from "./StarRating";
import { useNavigate } from "react-router-dom";

const ProductReviews = ({ userId }) => {

  const [reviews, setReviews] = useState([]);
  const navigate = useNavigate();

  const getReviews = () => {

		let data = JSON.stringify({
			sellerId: userId,
		});

		var config = {
			method: "post",
			url: Server2 + "/seller/reviews",
			headers: { "Content-Type": "application/json" },
			data: data,
		};
		axios(config)
			.then((response) => {
        console.log(response)
				setReviews(response.data);
			})
			.catch((err) => {
				console.log(err, "error");
			});
	}

  const [activeId, setActiveId] = useState(null);

  const toggle = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
  };

	useEffect(() => {
		getReviews();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userId]);

  return (
    <div className="bg-white">

      {/* Reviews List */}
      <div className="">

        {reviews.length === 0 ?
          <div className="text-muted mt-2 text-center pb-4">
            No reviews yet
          </div>
        :
          <div className="mt-1 mb-2 overflow-y-auto" style={{maxHeight: 260}}>
            {/* Main */}
            <div className="d-flex flex-column mx-1 px-2 gap-3">

              {reviews.map((r) => (
                <div className="d-flex" key={r._id}>
      
                  {/* Product */}
                  <div className="cursor-pointer" style={{marginRight: 12}} onClick={() => navigate(`/product/${r?.product?._id}`, { state: { item: r?.product._id }})}>
                    <div className="mt-1 pb-0 gap-2">
                      {r.product && (
                        <img
                          src={r?.product?.images[0]}
                          alt={'name'}
                          className="rounded-2 border border-white"
                          style={{
                            width: 70,
                            height: 70,
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* Review */}
                  <div className="flex-grow-1 cursor-pointer" onClick={() => toggle(r._id)}>
                    <p className="pb-0 pt-1">{r?.product?.productName}</p>
                    {r.review !== "" ?
                      // <p className='text-dark text-sm clamp-2'>
                      <p className={`text-dark text-sm ${activeId === r._id ? '' : 'clamp-2'}`}>
                       {r.review}
                      </p>
                    :
                      <p className="text-secondary mt-1 text-xs">
                        No written review
                      </p>
                    }
                  </div>

                  {/* Stars */}
                  <div className="mt-0">
                    <StarRating value={r.rating} size={17} disabled/>
                    <p className="pb-0 text-secondary" style={{fontSize: 12, marginBottom: 5}}>
                      {new Date(r.createdAt).toLocaleDateString()}
                    </p>
                  </div>

                </div>

                ))}
            </div>

          </div>
        }

      </div>

    </div>
  );
};

export default ProductReviews;